import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import type { SectionId } from './DesktopSidebarTabs';

export interface MobileBottomNavigationProps {
  activeSection: SectionId;
  /** Optional; section is synced from hash and scroll observer when using hash links */
  onSectionChange?: (section: SectionId) => void;
}

export const MobileBottomNavigation: React.FC<MobileBottomNavigationProps> = ({
  activeSection,
  onSectionChange,
}) => {
  const intl = useIntl();

  const tabs = [
    { id: 'overview' as const, label: 'jobDetailPage.section.overview', defaultLabel: 'Overview' },
    { id: 'company' as const, label: 'jobDetailPage.section.company', defaultLabel: 'Company' },
    { id: 'jobDetails' as const, label: 'jobDetailPage.section.jobDetails', defaultLabel: 'Details' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 w-full z-[60] flex items-center gap-2 px-3 py-2 border-t border-black/10 dark:border-gray-700 lg:hidden bg-white/95 dark:bg-gray-800/95 shadow rounded-t-2xl transition-colors duration-300 max-w-full overflow-hidden"
      style={{
        boxShadow: '0 -4px 24px 0 rgba(0,0,0,0.08)',
        backdropFilter: 'blur(24px) saturate(180%)',
        WebkitBackdropFilter: 'blur(24px) saturate(180%)',
        paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))',
        pointerEvents: 'auto',
      }}
    >
      {tabs.map((tab) => (
        <a
          key={tab.id}
          href={`#${tab.id}`}
          className={`flex-1 px-3 py-2 rounded-xl text-sm font-medium transition-colors text-center cursor-pointer ${
            activeSection === tab.id
              ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white'
              : 'text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 active:bg-gray-100 dark:active:bg-gray-700'
          }`}
        >
          <FormattedMessage id={tab.label} defaultMessage={tab.defaultLabel} />
        </a>
      ))}
    </nav>
  );
};
